import { motion } from "framer-motion";
import { AmazonButton } from "@/components/site/CTA";
import { MaskLine } from "@/components/site/Reveal";
import { AMAZON_WWDSS } from "@/lib/site";

export const FinalDecision = () => {
  return (
    <section
      data-testid="final-section"
      className="relative bg-ink-pure py-28 sm:py-40"
    >
      <div className="mx-auto max-w-[1500px] px-6 sm:px-10">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="font-sans text-xs uppercase tracking-[0.4em] text-bone-muted mb-16 sm:mb-24 max-w-xs leading-relaxed"
        >
          There comes a point when you have to decide.
        </motion.p>

        <div className="flex flex-col gap-6">
          <MaskLine
            delay={0}
            amount={0.3}
            className="font-serif uppercase tracking-tight text-bone-muted text-4xl sm:text-6xl lg:text-7xl leading-[0.95]"
          >
            Stay where you are.
          </MaskLine>

          <div className="mt-14 sm:mt-24 space-y-2">
            <MaskLine
              delay={0.15}
              amount={0.3}
              className="font-serif uppercase tracking-tight text-bone text-5xl sm:text-7xl lg:text-8xl xl:text-[8.5rem] leading-[0.9] break-words"
            >
              Or find out
            </MaskLine>
            <MaskLine
              delay={0.28}
              amount={0.3}
              className="font-serif uppercase tracking-tight text-bone text-5xl sm:text-7xl lg:text-8xl xl:text-[8.5rem] leading-[0.9] break-words"
            >
              what happens
            </MaskLine>
            <MaskLine
              delay={0.41}
              amount={0.3}
              className="font-serif uppercase tracking-tight text-bone text-5xl sm:text-7xl lg:text-8xl xl:text-[8.5rem] leading-[0.9] break-words"
            >
              if you don’t.
            </MaskLine>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.3 }}
          className="mt-24 flex flex-col items-start gap-6"
        >
          <AmazonButton href={AMAZON_WWDSS} testId="final-buy-button">
            Get the Book
          </AmazonButton>
          <p className="font-sans text-[0.7rem] uppercase tracking-[0.32em] text-bone-muted leading-loose">
            Women Who Don’t Sit Still
            <span className="block">By Grace Edwards</span>
            <span className="block text-bone-muted/60">Available on Amazon</span>
          </p>
        </motion.div>
      </div>
    </section>
  );
};
